document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("mch-popup");

    if (!popup) return;

    const overlay = popup.querySelector(".mch-popup__overlay");
    const closeBtn = popup.querySelector(".mch-popup__close");

    // ==========================================================
    // Detect Shopify Theme Editor
    // ==========================================================

    const isThemeEditor =
        typeof Shopify !== "undefined" &&
        Shopify.designMode;

    // ==========================================================
    // Homepage Only (except Theme Editor)
    // ==========================================================

    if (!isThemeEditor && window.location.pathname !== "/") {
        return;
    }

    // ==========================================================
    // Popup Delay (Theme Setting)
    // ==========================================================

    let popupDelay = 3;

    if (popup.dataset.delay) {
        popupDelay = parseInt(popup.dataset.delay, 10);
    }

    // ==========================================================
    // Don't show again for 90 days
    // (Ignored in Theme Editor)
    // ==========================================================

    if (!isThemeEditor) {

        const dismissed = localStorage.getItem("mchPopupDismissed");

        if (dismissed) {

            const expires = parseInt(dismissed, 10);

            if (Date.now() < expires) {
                return;
            }

        }

    }

    // ==========================================================
    // Show Popup
    // ==========================================================

    const delay = isThemeEditor ? 250 : popupDelay * 1000;

    setTimeout(() => {

        popup.classList.add("active");

        document.body.style.overflow = "hidden";

    }, delay);

    // ==========================================================
    // Close Popup
    // ==========================================================

    function closePopup() {

        popup.classList.remove("active");

        document.body.style.overflow = "";

        // Don't save dismissal while editing
        if (isThemeEditor) return;

        const ninetyDays = Date.now() + (90 * 24 * 60 * 60 * 1000);

        localStorage.setItem(
            "mchPopupDismissed",
            ninetyDays
        );

    }

    // ==========================================================
    // Events
    // ==========================================================

    if (closeBtn) {
        closeBtn.addEventListener("click", closePopup);
    }

    if (overlay) {
        overlay.addEventListener("click", closePopup);
    }

    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape") {
            closePopup();
        }

    });

});